var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { TemplateExposeGroup } from '../interface';
import { ConfigTemplateWorkflowInputFieldDto } from './ConfigTemplateWorkflowInputFieldDto';
export class ConfigTemplateWorkflowConfigDto {
    constructor() {
        this.delay = 0;
        this.time = '08:00';
    }
}
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4', example: 'e12acc6f-2f34-442c-92d3-d4199fb12345' }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", String)
], ConfigTemplateWorkflowConfigDto.prototype, "workflowDefinitionId", void 0);
__decorate([
    ApiProperty({ description: 'Workflow definition title', example: 'Message № 1', type: () => String }),
    Expose({ groups: [TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ConfigTemplateWorkflowConfigDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ description: 'Flag for enabling workflow definition.', type: () => Boolean, default: false }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", Boolean)
], ConfigTemplateWorkflowConfigDto.prototype, "isEnabled", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Delay in days.', example: 1, type: () => Number }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", Number)
], ConfigTemplateWorkflowConfigDto.prototype, "delay", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Time in HH:MM format', example: '20:30', type: () => String }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", String)
], ConfigTemplateWorkflowConfigDto.prototype, "time", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Time zone', type: () => String, example: 'America/New_York' }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", String)
], ConfigTemplateWorkflowConfigDto.prototype, "defaultTimeZone", void 0);
__decorate([
    ApiProperty({ description: 'List of campaign tempalte input workflow fields.', type: () => ConfigTemplateWorkflowInputFieldDto, isArray: true }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    Type(() => ConfigTemplateWorkflowInputFieldDto),
    __metadata("design:type", Array)
], ConfigTemplateWorkflowConfigDto.prototype, "fields", void 0);
//# sourceMappingURL=ConfigTemplateWorkflowConfigDto.js.map